import { MONTH_NAMES } from "../constants";

export const handleFormatTime = (time) => {
  let seconds = time?.split(":")[1];
  let date = new Date(seconds * 1000);

  let hours = String(date.getHours()).padStart(2, "0");
  let minutes = String(date.getMinutes()).padStart(2, "0");
  let day = String(date.getDate()).padStart(2, "0");
  let month = MONTH_NAMES[date.getMonth()];
  let year = date.getFullYear();

  return `${hours}:${minutes}, ${month} ${day}, ${year}`;
};

export const toISOFormat = (input) => {
  if (!input) return "";

  let [datePart, timePart] = input.split(", ");
  if (!datePart || !timePart) throw new Error("Invalid input format");

  let [day, monthYear] = datePart.split(" ");
  day = day.padStart(2, "0");

  let [monthStr, yearStr] = monthYear.split("'");
  let month = String(new Date(`${monthStr} 1`).getMonth() + 1).padStart(2, "0");
  let year = `20${yearStr}`;

  let timeMatch = timePart.match(/(\d{1,2}):(\d{2})(am|pm)/i);
  if (!timeMatch) throw new Error("Invalid time format");

  let [_, hours, minutes, period] = timeMatch;
  hours =
    period.toLowerCase() === "pm" && hours !== "12"
      ? parseInt(hours) + 12
      : period.toLowerCase() === "am" && hours === "12"
      ? 0
      : hours;

  hours = String(hours).padStart(2, "0");
  minutes = String(minutes).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const fromISOFormat = (input) => {
  if (!input) return "";

  let date = new Date(input);
  let day = String(date.getDate()).padStart(2, "0");
  let monthStr = date.toLocaleString("en", { month: "short" });
  let year = `'${String(date.getFullYear()).slice(2)}`;

  let hours = date.getHours();
  let minutes = String(date.getMinutes()).padStart(2, "0");
  let period = hours >= 12 ? "pm" : "am";
  let formattedHour = String(hours % 12 || 12).padStart(2, "0");

  return `${day} ${monthStr}${year}, ${formattedHour}:${minutes}${period}`;
};
